//TODO: Refactor if other account asks for this feature
export function getDateOffset(account) {
    //console.log(account);
    if (account === "823")
        return 60;

    return 30;
}
